import script from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExportJSON.vue?vue&type=script&lang=ts&setup=true"

import "./ExportJSON.vue?vue&type=style&index=0&id=6a7223ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7223ca"]])

export default __exports__